<template>
  <el-drawer title="司机列表" @close="closeDialog"  direction="ltr" size="50%"  :visible="zhipaiFlag">
    <div style="padding-top:20px">
      <el-form  :inline="true"  :model="searchFrom2"  class="demo-form-inline"  label-width="80px"  size="mini"  >
        <el-form-item label="司机姓名">
          <el-input placeholder="" type="textarea" v-model="searchFrom2.driverName"  ></el-input>
        </el-form-item>
        <el-button type="primary" @click="searchFn2" >查询</el-button>
      </el-form>
      <el-table height="75vh" size="mini" ref="tabref" :data="tableList2" style="width:100%" border center @select='selectGoods'
       @selection-change="handleSelectionChange" @select-all="quanxuan($event)"  @row-click="rowClick" :row-key="getRowKey">
        <el-table-column type="selection" width="55" ></el-table-column>
        <el-table-column type="index"  label="序号" width="60"></el-table-column>
        <el-table-column prop="name"  label="司机姓名"></el-table-column>
        <el-table-column prop="mobile"  label="司机电话"></el-table-column>
        <el-table-column property="identityNo" label="司机身份证号" width="200">
          <template scope="scope">
           <p>
            {{scope.row.identityNo.replace(/^(.{4})(?:\d+)(.{4})$/, "$1**********$2")}}
          </p>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div>
        <el-pagination background @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
          :current-page="searchFrom2.pageNo" :page-sizes="[25, 50, 100]" :page-size="searchFrom2.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total2">
        </el-pagination>
      </div>
    </div>
    <el-drawer title="已选司机" size="98%" @close="closeDialog"   class="rightDrawer"
    :modal-append-to-body="false" :modal="false"  :visible="zhipaiFlag">
      <el-table height="80vh" size="mini" ref="tabref1" :data="tableList" style="width:100%" border center>
        <el-table-column type="index"  label="序号" width="60"></el-table-column>
        <el-table-column type="index" width="55" label="操作">
          <template scope="scope">
            <el-button type="text" @click="delFn(scope.row,scope.$index)">删除</el-button>
          </template >
        </el-table-column>
        <el-table-column prop="driverName"  label="司机姓名"></el-table-column>
        <el-table-column prop="mobile"  label="司机电话"></el-table-column>
        <el-table-column property="identityNo" label="司机身份证号" width="200">
          <template scope="scope">
           <p >
            {{scope.row.idNumber.replace(/^(.{4})(?:\d+)(.{4})$/, "$1**********$2")}}
          </p>
          </template>
        </el-table-column>
      </el-table>
      <div class="footerBtn">
        <el-button  @click="closeDialog"  >取消</el-button>
        <el-button  type="primary"  @click="saveFn()">确定</el-button>
      </div>
    </el-drawer>
  </el-drawer>
</template>

<script>
import { cDlist, addOrDeleteBinddingDriver, getSourceBinddingDrivers } from '@/api/newTMS'
export default {
  name: 'zhipai',
  components: {

  },
  props: {
    zhipaiFlag: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }

  },
  data () {
    return {
      searchFrom2: {
        pageNo: 1,
        pageSize: 50
      },
      tableList2: [],
      total2: 0,
      tableList: [],
      multipleSelection: [],
      delIds: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    cDlist(this.searchFrom2).then(res => {
      this.tableList2 = res.list
      this.total2 = res.total
      getSourceBinddingDrivers({
        'orderId': this.rowData.orderId,
        'orderNo': this.rowData.orderNo
      }).then(res => {
        this.tableList = res
        this.tableList.forEach(val => {
          let json = this.tableList2.filter(item => item.id == val.driverId)
          if (json.length == 1) {
            this.$refs.tabref.toggleRowSelection(json[0])
          }
        })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    })
  },
  methods: {
    getRowKey (row) {
      return row.id
    },
    saveFn () {
      let addArr = []
      this.tableList.forEach(item => {
        if (!item.id) {
          addArr.push(item)
        }
      })
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      addOrDeleteBinddingDriver({
        orderInfo: [{
          'orderId': this.rowData.orderId,
          'orderNo': this.rowData.orderNo
        }],
        'addDrivers': addArr,
        'deleteDrivers': this.delIds
      }).then(res => {
        loading.close()
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.$emit('update:zhipaiFlag', false)
        this.$parent.searchFn()
      }).catch(error => {
        loading.close()
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    delFn (row, index) {
      if (row.id) {
        this.delIds.push(row.id)
      }
      this.tableList.splice(index, 1)
      this.tableList2.forEach(item => {
        if (item.id == row.driverId) {
          this.$refs.tabref.toggleRowSelection(item, false)
        }
      })
    },
    rowClick (row, column, event) {
      let refsElTable = this.$refs.tabref // 获取表格对象
      let findRow = this.multipleSelection.find(c => c.id == row.id) // 找到选中的行
      if (findRow) {
        refsElTable.toggleRowSelection(row, false) // 如过重复选中，则取消选中
      } else {
        refsElTable.toggleRowSelection(row, true) // 实现选中行中选中事件
      }
      let selectData = this.$refs.tabref.selection
      this.selectGoods(selectData, row)
    },
    selectGoods (list, row) {
      if (list.includes(row)) {
        this.tableList.push({
          'driverId': row.id,
          'driverName': row.name,
          'idNumber': row.identityNo,
          'mobile': row.mobile
        })
      } else {
        // 取消勾选时做的事，arguments[1]是当前取消勾选的项
        this.tableList.forEach((item, index) => {
          if (arguments[1].id == item.driverId) {
            if (item.id) {
              this.delIds.push(item.id)
            }
            this.tableList.splice(index, 1)
          }
        })
      }
    },
    // 全选
    quanxuan (e) {
      if (e.length == 0) {
        let arr = this.tableList.filter(item => {
          let json = this.tableList2.find(c => c.id == item.driverId)
          if (json) {
            if (item.id) {
              this.delIds.push(item.id)
            }
            return false
          } else {
            return true
          }
        })
        this.tableList = arr
      } else {
        e.forEach(item => {
          let json = this.tableList.find(c => c.driverId == item.id)
          if (!json) {
            let params = {
              'driverId': item.id,
              'driverName': item.name,
              'idNumber': item.identityNo,
              'mobile': item.mobile
            }
            this.tableList.push(params)
          }
        })
      }
    },

    // 表格选中事件
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 实现选中高亮
    rowClassName ({ row, rowIndex }) {
      let rowName = ''
      let findRow = this.multipleSelection.find(c => c.rowIndex === row.rowIndex)
      if (findRow) {
        rowName = 'current-row'
      } else {
        rowName = ''
      }
      return rowName // 也可以再加上其他类名 如果有需求的话
    },
    searchFn2 () {
      if (this.searchFrom2.driverName) {
        this.searchFrom2.driverUserNames = this.searchFrom2.driverName.replace(/\n/g, ',')
      } else {
        this.searchFrom2.driverUserNames = ''
      }
      cDlist(this.searchFrom2).then(res => {
        this.tableList2 = res.list
        this.total2 = res.total
        this.$nextTick(() => {
          this.tableList.forEach(val => {
            let json = this.tableList2.filter(item => item.id == val.driverId)
            if (json.length == 1) {
              this.$refs.tabref.toggleRowSelection(json[0])
            }
          })
        })
      })
    },
    // 每页条数
    handleSizeChange2 (val) {
      this.searchFrom2.pageSize = val
      this.searchFn2(this.searchFrom)
    },
    // 当前页
    handleCurrentChange2 (val) {
      this.searchFrom2.pageNo = val
      this.searchFn2()
    },
    closeDialog () {
      this.$emit('update:zhipaiFlag', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.current-row{
  color: #409eff;
}
/deep/.el-textarea__inner{
    height:72px;
}
</style>
